export default {
    'validation.string.alphanum': 'должено содержать только буквенно-цифровые символы',
    'validation.string.base': 'должно быть строкой',
    'validation.string.base64': 'должно быть правильной строкой base64',
    'validation.string.creditCard': 'должно быть кредитной картой',
    'validation.string.dataUri': 'должно быть правильной строкой dataUri',
    'validation.string.domain': 'должно содержать правильное имя домена',
    'validation.string.email': 'введите правильный адрес электронной почты',
    'validation.string.empty': 'не может быть пустым',
    'validation.string.guid': 'должно быть правильным GUID',
    'validation.string.hex': 'должно содержать только шестнадцатеричные символы',
    'validation.string.hexAlign': 'шестнадцатеричное декодированное представление должно быть выровнено по байту',
    'validation.string.hostname': 'должно быть допустимым именем хоста',
    'validation.string.ip': 'должно быть действительным IP-адресом с {cidr} CIDR',
    'validation.string.ipVersion': 'должно быть действительным IP-адресом одной из следующих версий {version} с {cidr} CIDR',
    'validation.string.isoDate': 'должно быть в формате iso',
    'validation.string.isoDuration': 'должно соотвествовать формату ISO 8601',
    'validation.string.length': 'длина должна быть ровно {limit}',
    'validation.string.lowercase': 'должно содержать только строчные символы',
    'validation.string.max': 'длина должна быть не более 0 символов | длина должна быть не более {n} символа | длина должна быть не более {n} символов | длина должна быть не более {n} символов',
    'validation.string.min': 'длина должна быть не менее 0 символов | длина должна быть не менее {n} символа | длина должна быть не менее {n} символов | длина должна быть не менее {n} символов',
    'validation.string.normalize': 'должно быть нормализован в Юникоде в форме {form}',
    'validation.string.token': 'должно содержать только буквы, цифры и символы подчеркивания',
    'validation.string.pattern.base': 'значение "{value}" не соответствует требуемому шаблону: {regex}',
    'validation.string.pattern.name': 'значение "{value}" не соответствует шаблону {name}',
    'validation.string.pattern.invert.base': 'значение "{value}" соответствует инвертированному шаблону: {regex}',
    'validation.string.pattern.invert.name': 'значение "{value}" соответствует инвертированному шаблону {name}',
    'validation.string.trim': 'не должно быть начальных или конечных пробелов',
    'validation.string.uri': 'должно быть действительным uri',
    'validation.string.uriCustomScheme': 'должно быть допустимым URI со схемой, соответствующей шаблону {scheme}',
    'validation.string.uriRelativeOnly': 'должно быть допустимым относительным URI',
    'validation.string.uppercase': 'должно содержать только заглавные буквы',

    'validation.number.base': 'должно быть числом',
    'validation.number.greater': 'должно быть больше, чем {limit}',
    'validation.number.infinity': 'не может быть бесконечностью',
    'validation.number.integer': 'должно быть целым числом',
    'validation.number.less': 'должно быть меньше {limit}',
    'validation.number.max': 'должно быть меньше или равно {limit}',
    'validation.number.min': 'должно быть больше или равно {limit}',
    'validation.number.multiple': 'должно быть кратным {multiple}',
    'validation.number.negative': 'должно быть отрицательным числом',
    'validation.number.port': 'должно быть правильным адресом порта',
    'validation.number.positive': 'должно быть положительным числом',
    'validation.number.precision': 'должно содержать не более {limit} десятичных знаков',
    'validation.number.unsafe': 'должен быть безопасный номер',

    'validation.date.base': 'должно быть правильной датой',
    'validation.date.format': 'должно быть в формате {format}',
    'validation.date.greater': 'должно быть больше, чем "{limit}"',
    'validation.date.less': 'должно быть меньше "{limit}"',
    'validation.date.max': 'должно быть меньше или равно "{limit}"',
    'validation.date.min': 'должно быть больше или равно "{limit}"',
    'validation.date.format.iso': 'должно соответствовать формату ISO 8601',
    'validation.date.format.javascript': 'должно быть timestamp или содержать количество миллисекунд',
    'validation.date.format.unix': 'должно быть timestamp или содержать количество секунд',

    'validation.alternatives.all': 'не соответствует всем необходимым типам',
    'validation.alternatives.any': 'не соответствует ни одному из разрешенных типов',
    'validation.alternatives.match': 'не соответствует ни одному из разрешенных типов',
    'validation.alternatives.one': 'соответствует более чем одному разрешенному типу',
    'validation.alternatives.types': 'должно быть одним из {types}',

    'validation.any.custom': 'не удалось выполнить пользовательскую проверку, потому что {errorMessage}',
    'validation.any.default': 'произошла ошибка при запуске метода по умолчанию',
    'validation.any.failover': 'произошла ошибка при запуске метода отработки отказа',
    'validation.any.invalid': 'содержит недопустимое значение',
    'validation.any.only': 'должно быть одним из {valids}',
    'validation.any.ref': '{arg} ссылается на "{ref}", что {reason}',
    'validation.any.required': 'необходимо',
    'validation.any.unknown': 'не разрешено',

    'validation.array.base': 'должен быть массивом',
    'validation.array.excludes': 'содержит исключенное значение',
    'validation.array.hasKnown': 'не содержит хотя бы одного обязательного совпадения для типа "{patternLabel}"',
    'validation.array.hasUnknown': 'не содержит хотя бы одно обязательное совпадение',
    'validation.array.includes': 'не соответствует ни одному из разрешенных типов',
    'validation.array.includesRequiredBoth': 'не содержит {knownMisses} и {unknownMisses} другие обязательные значения',
    'validation.array.includesRequiredKnowns': 'не содержит {knownMisses}',
    'validation.array.includesRequiredUnknowns': 'не содержит {unknownMisses} обязательных значений',
    'validation.array.length': 'должно содержать 0 элементов | должно содержать {n} элемент | должно содержать {n} элементов | должно содержать {n} элементов',
    'validation.array.max': 'должно содержать не более 0 элементов | должно содержать не более {n} элемента | должно содержать не более {n} элементов |  должно содержать не более {n} элементов',
    'validation.array.min': 'должно содержать как минимум {n} элементов | должно содержать как минимум {n} элемент | должно содержать как минимум {n} элемента | должно содержать как минимум {n} элемент',
    'validation.array.orderedLength': 'должно содержать не более {limit} элементов',
    'validation.array.sort': 'должно быть отсортировано в порядке {order} по {by}',
    'validation.array.sort.mismatching': 'невозможно отсортировать из-за несовпадения типов',
    'validation.array.sort.unsupported': 'невозможно отсортировать из-за неподдерживаемого типа {type}',
    'validation.array.sparse': 'не должен быть редким элементом массива',
    'validation.array.unique': 'содержит повторяющееся значение',

    'validation.binary.base': 'должно быть массивом байт или строкой',
    'validation.binary.length': 'должно быть ровно {limit} байт',
    'validation.binary.max': 'должно быть меньше или равно {limit} байт',
    'validation.binary.min': 'должно быть не менее {limit} байт',

    'validation.boolean.base': 'должно быть бинарным',

    'validation.function.arity': 'должно иметь арность {n}',
    'validation.function.class': 'должно быть классом',
    'validation.function.maxArity': 'должно иметь арность, меньшую или равную {n}',
    'validation.function.minArity': 'должно иметь арность больше или равную {n}',

    'validation.object.and': 'содержит {presentWithLabels} без обязательных пиров {missingWithLabels}',
    'validation.object.assert': 'неверно, потому что утверждение не выполнено',
    'validation.object.base': 'должен быть типа {type}',
    'validation.object.instance': 'должен быть экземпляром "{type}"',
    'validation.object.length': 'должно иметь ровно {limit} полей',
    'validation.object.max': 'должно быть меньше или равно полям {limit}',
    'validation.object.min': 'должно иметь как минимум {limit} поля',
    'validation.object.missing': 'должно содержать хотя бы один из {peersWithLabels}',
    'validation.object.nand': '"{mainWithLabel}" не должен существовать одновременно с {peersWithLabels}',
    'validation.object.oxor': 'содержит конфликт между необязательными эксклюзивными пирами {peersWithLabels}',
    'validation.object.pattern.match': 'ключи не соответствуют требованиям шаблона',
    'validation.object.refType': 'должно быть ссылкой Joi',
    'validation.object.regex': 'должно быть объектом RegExp',
    'validation.object.rename.multiple': 'не может переименовать "{from}", поскольку несколько переименований отключены, а другой ключ уже переименован в "{to}"',
    'validation.object.rename.override': 'не может переименовать "{from}", потому что переопределение отключено и цель "{to}" существует',
    'validation.object.schema': 'должно быть схемой Joi типа {type}',
    'validation.object.unknown': 'не допускается',
    'validation.object.with': '"{mainWithLabel}" отсутствует необходимый узел "{peerWithLabel}"',
    'validation.object.without': '"{mainWithLabel}" конфликт с запрещенным узлом "{peerWithLabel}"',
    'validation.object.xor': 'содержит конфликт между эксклюзивными пирами {peersWithLabels}',

    'validation.symbol.base': 'должно быть символом',
    'validation.symbol.map': 'должно быть одним из {map}',

}